import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Home from "./views/Home.vue";
import AutonomousDriving from "./views/AutonomousDriving.vue"
import SmartHome from "./views/SmartHome.vue"
import MobileApps from "./views/MobileApps.vue"
import SmartRetail from "./views/SmartRetail.vue"
import Manufacturing from "./views/Manufacturing.vue"
import Robotics from "./views/Robotics.vue"
import DataCollection from "./views/DataCollection.vue"
import DataCleaning from "./views/DataCleaning.vue"
import DataAnnotation from "./views/DataAnnotation.vue"
import DataAugmentation from "./views/DataAugmentation.vue"
import About from "./views/About.vue";
import Careers from "./views/Careers.vue";
import Contact from "./views/Contact.vue";
import Login from "./views/Login.vue";
import TermsOfUse from "./views/TermsOfUse.vue";
import Privacy from "./views/Privacy.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "components",
      components: {
        header: AppHeader,
        default: Home,
        footer: AppFooter
      }
    },
    {
      path: "/solutions/autonomous-driving",
      name: "autonomous-driving",
      components: {
        header: AppHeader,
        default: AutonomousDriving,
        footer: AppFooter
      }
    },
    {
      path: "/solutions/smart-home",
      name: "smart-home",
      components: {
        header: AppHeader,
        default: SmartHome,
        footer: AppFooter
      }
    },
    {
      path: "/solutions/mobile-apps",
      name: "mobile-apps",
      components: {
        header: AppHeader,
        default: MobileApps,
        footer: AppFooter
      }
    },
    {
      path: "/solutions/smart-retail",
      name: "smart-retail",
      components: {
        header: AppHeader,
        default: SmartRetail,
        footer: AppFooter
      }
    },
    {
      path: "/solutions/manufacturing",
      name: "manufacturing",
      components: {
        header: AppHeader,
        default: Manufacturing,
        footer: AppFooter
      }
    },
    {
      path: "/solutions/robotics",
      name: "robotics",
      components: {
        header: AppHeader,
        default: Robotics,
        footer: AppFooter
      }
    },
    {
      path: "/services/data/collection",
      name: "data-collection",
      components: {
        header: AppHeader,
        default: DataCollection,
        footer: AppFooter
      }
    },
    {
      path: "/services/data/cleaning",
      name: "data-cleaning",
      components: {
        header: AppHeader,
        default: DataCleaning,
        footer: AppFooter
      }
    },
    {
      path: "/services/data/annotation",
      name: "data-annotation",
      components: {
        header: AppHeader,
        default: DataAnnotation,
        footer: AppFooter
      }
    },
    {
      path: "/services/data/augmentation",
      name: "data-augmentation",
      components: {
        header: AppHeader,
        default: DataAugmentation,
        footer: AppFooter
      }
    },
    {
      path: "/about",
      name: "about",
      components: {
        header: AppHeader,
        default: About,
        footer: AppFooter
      }
    },
    {
      path: "/careers",
      name: "careers",
      components: {
        header: AppHeader,
        default: Careers,
        footer: AppFooter
      }
    },
    {
      path: "/contact",
      name: "contact",
      components: {
        header: AppHeader,
        default: Contact,
        footer: AppFooter
      }
    },
    {
      path: "/login",
      name: "login",
      components: {
        header: AppHeader,
        default: Login,
        footer: AppFooter
      }
    },
    {
      path: "/terms-of-use",
      name: "terms-of-use",
      components: {
        header: AppHeader,
        default: TermsOfUse,
        footer: AppFooter
      }
    },
    {
      path: "/privacy",
      name: "privacy",
      components: {
        header: AppHeader,
        default: Privacy,
        footer: AppFooter
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
